import { text } from '../../../../DOM/text/TEXT.js';
import CONFIRM from '../../../../COMPONENT/dialog/confirm/CONFIRM.js';
import SECTION, { section } from '../../../../DOM/section/SECTION.js';
import { div } from '../../../../DOM/div/DIV.js';
import { heading } from '../../../../DOM/heading/HEADING.js';
import { ul } from '../../../../DOM/LIST/ul/UL.js';
import { ol } from '../../../../DOM/LIST/ol/OL.js';
import { dl } from '../../../../DOM/LIST/dl/DL.js';
import { dt } from '../../../../DOM/LIST/dl/dt/DT.js';
import { dd } from '../../../../DOM/LIST/dl/dd/DD.js';
import { li } from '../../../../DOM/LIST/li/LI.js';
import STRING from '../../../../../STRING.js';
/** A CONFIRM dialog for reviewing Breach Details
*/
export default class CONFIRM_ReviewBreach extends CONFIRM {
    constructor(node, model) {
        super(node, model);
        this.addClass('confirm-review-breach');
    }
    /** Populates the breach summary with the provided data
     * @param {any} data - The breach data (can be formResults or API response)
     * @return void
     */
    populateBreachSummary(data) {
        console.log('Populating breach summary with data:', data);
        let review = new SECTION(this.content, section(heading(3, 'Report Summary')));
        let breachType = review.addSection(section(heading(4, 'Breach Type')));
        let breachTypeDL = breachType.content.addDL(dl());
        breachTypeDL.addDT(dt('Breach'));
        breachTypeDL.addDD(dd(`${data['breach-type-fs']['breach-type-group'][0]['breach-type']}`));
        // Contact Details
        let contactName = new STRING(`${data['contact-info-fs']['contact-group'][0]['first-name']} ${data['contact-info-fs']['contact-group'][0]['last-name']}`).trim();
        let contactEmail = new STRING(`${data['contact-info-fs']['contact-group'][0]['email-address']}`).trim();
        let contactPhone = new STRING(`${data['contact-info-fs']['contact-group'][0]['phone-number']}`).trim();
        if (contactName !== '' || contactEmail !== '' || contactPhone !== '') {
            let contactInfo = review.addSection(section(heading(4, 'Contact Information')));
            let contactInfoDL = contactInfo.content.addDL(dl());
            if (contactName !== '') {
                contactInfoDL.addDT(dt('Name'));
                contactInfoDL.addDD(dd(`${data['contact-info-fs']['contact-group'][0]['first-name']} ${data['contact-info-fs']['contact-group'][0]['last-name']}`));
            }
            if (contactEmail !== '') {
                contactInfoDL.addDT(dt('Email'));
                contactInfoDL.addDD(dd(`${data['contact-info-fs']['contact-group'][0]['email-address']}`));
            }
            if (contactPhone !== '') {
                contactInfoDL.addDT(dt('Phone'));
                contactInfoDL.addDD(dd(`${data['contact-info-fs']['contact-group'][0]['phone-number']}`));
            }
        }
        // Contact Dates
        if (contactName !== '' || contactEmail !== '' || contactPhone !== '') {
            if (data['contact-dates-fs'] && data['contact-dates-fs']['contact-dates-group']) {
                let contactDates = review.addSection(section(heading(4, 'Contact Dates')));
                let contactDatesOL = contactDates.content.addOL(ol('date-item'));
                data['contact-dates-fs']['contact-dates-group'].forEach((group, index) => {
                    if (`${group['time-start']}` === '' && `${group['time-end']}` === '') {
                        contactDatesOL.addLI(li(`<span name='day'>${group['preferred-contact-date']}</span>`));
                    }
                    else {
                        contactDatesOL.addLI(li(`<span name='day'>${group['preferred-contact-date']}</span> between <span name='time-start'>${group['time-start']}</span> and <span name='time-end'>${group['time-end']}</span>`));
                    }
                });
            }
        }
        // Breacher Details
        let breacherDetails = review.addSection(section(heading(4, 'Breacher Details')));
        // let breacherList = breacherDetails.content.addUL(ul('breach-summary-list'));
        let breacherUL = breacherDetails.content.addUL(ul());
        data['breach-details-fs']['breach-details-group'].forEach((group, index) => {
            let person = data['breach-details-fs']['breach-details-group'][index];
            let personDetails = breacherUL.addLI(li(`Individual ${index + 1}`));
            let personDetailsDL = personDetails.addDiv(div('breacher')).addDL(dl());
            personDetailsDL.addDT(dt('Name'));
            personDetailsDL.addDD(dd(`${person['first-name']} ${person['last-name']}`));
            personDetailsDL.addDT(dt('Department'));
            personDetailsDL.addDD(dd(`${person['department'] || 'N/A'}`));
        });
        // Management Involved
        let mgmtSection = review.addSection(section(heading(4, 'Management Involvement')));
        if (data['management-involved-fs'] && data['management-involved-fs']['management-involved-group']) {
            let mgmtInvolved = data['management-involved-fs']['management-involved-group'][0]['management-involved'];
            // let mgmtInvolvedData = mgmtSection.content.addSpan(text(`Management Involved: ${mgmtInvolved}`));
            let definitionList = mgmtSection.content.addDL(dl());
            definitionList.addDT(dt('Involved'));
            definitionList.addDD(dd(`${mgmtInvolved}`));
            let mgmtDetailArr = data['management-involved-fs']['management-involved-detail'] || [];
            if (data['management-involved-fs']['management-involved-group'][0]['management-involved'] === 'Yes' && data['management-involved-fs']['management-involved-detail']) {
                let definitionList = mgmtSection.content.addDL(dl());
                definitionList.addDT(dt('Manager'));
                definitionList.addDD(dd(`${mgmtDetailArr[0]['first-name']} ${mgmtDetailArr[0]['last-name']}`));
                definitionList.addDT(dt('Department'));
                definitionList.addDD(dd(`${mgmtDetailArr[0]['department'] || 'N/A'}`));
            }
        }
        // Breach Comments
        let commentSection = review.addSection(section(heading(4, 'Breach Comments')));
        commentSection.content.addP(text(`${data['breach-notes-fs']['breach-notes-group'][0]['breach-notes'] || 'N/A'}`));
    }
}
